import React, { useState, useRef, useEffect } from 'react';

import { useMediaQuery } from 'react-responsive';
import ModalWrapper from "../Global/ModalWrapper";
import Markup from '../../markup';
import { device } from '../../const/device';
import {searchByString} from "../../utils/Search";
import debounce from "lodash/debounce"

type SelectBoxItems = {
  title: string,
  val: string 
}


type SelectBoxType = {
  items: SelectBoxItems[] | string[],
  selected: string,
  setSelected: Function,
  themeColor: string,
  isDesign?: boolean,
}

const itemsToObj = (items) => typeof items[0] === 'string' ? items.map(item => ({ title: item, val: item })) : items;

function SelectBox({ items, selected, setSelected, themeColor, isDesign = false }: SelectBoxType) {
  const fontItems = itemsToObj(items);
  const [open, setOpen] = useState<boolean>(false);
  const isTablet = useMediaQuery({ query: `(${device.tablet})` });
  const [fontlist, setFontList] = useState(fontItems);
  const [selectedYPosition, setSelectedYPosition] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const selectRef = useRef(null);

  useEffect(() => {
      window.addEventListener("click", hideSelectBlock);
      return () => window.removeEventListener("click", hideSelectBlock);
  },[])

  const hideSelectBlock = (e) => {
      if(!isTablet && selectRef.current && !selectRef.current.contains(e.target)) {
          setSearchValue("");
          setFontList(fontItems);
          setOpen(false);
      }
  }

  const toggleSelectBox = () => {
   if(open){
       setSearchValue("");
       setFontList(fontItems);
   }
      setOpen(open => !open);
  }

  const onSearch = (e) => {
      let result = []
      let searchString = (e.target.value).trim();
      setSearchValue(e.target.value);
      if (searchString) {
        if (~searchString.search(/^[A-Za-z-\s]{0,100}$/)) {
          fontItems.forEach(font => {
            if (searchByString(font.title, searchString)) result.push(font);
          })
          setFontList(result);
        }
      } else setFontList(fontItems);
  }

  return (
    <>
      <Markup.Global.SelectBox.Container
        active={open}
        ref={selectRef}
        themeColor={themeColor}
      >
        <Markup.Global.SelectBox.Selected
          selected={!!selected}
          active={open}
          onClick={toggleSelectBox}
          themeColor={themeColor}
        >
          {selected && fontItems.length ? fontItems.find(i => i.val === selected)?.title ?? selected : 'No selected'}
        </Markup.Global.SelectBox.Selected>
        {open && !isTablet && (
          <>
          <Markup.Global.Input.FontsSearchWrap themeColor={themeColor}>
              <Markup.Global.Input.SearchItem defaultValue={searchValue} placeholder={`Search ${isDesign ? 'patterns' : 'fonts'}`} onChange={debounce(onSearch,150)} themeColor={themeColor}/>
          </Markup.Global.Input.FontsSearchWrap>

          <Markup.Global.SelectBox.ContentContainer
            ref={(node) => node?.scroll(0, (selectedYPosition - node?.getBoundingClientRect()?.top) - 40) }
            themeColor={themeColor}
          >
              {fontlist.map((item) =>
                <Markup.Global.SelectBox.Item 
                  key={item.val} 
                  selected={item.val === selected}
                  onClick={() => {
                    setSelected(item.val);
                    toggleSelectBox();
                  }}
                  ref={(ref) => item.val === selected && setSelectedYPosition(ref?.getBoundingClientRect()?.top) }
                >{item.title}
              </Markup.Global.SelectBox.Item>)}
          </Markup.Global.SelectBox.ContentContainer>
          </>
        )}
      </Markup.Global.SelectBox.Container>

      {isTablet && open && (
        <ModalWrapper 
          modalOnToogle={setOpen} 
          modalStatus={open}
        >
          <>
              <Markup.Global.SelectBox.TitleContainer>
                  <Markup.Global.SelectBox.TitleText>
                    SELECT {isDesign ? 'PATTERN' : "FONT"}
                    <Markup.Global.Button.ButtonIconClose onClick={toggleSelectBox} />
                  </Markup.Global.SelectBox.TitleText>

                  <Markup.Global.SelectBox.TitleSearch>
                    <Markup.Global.Input.SearchItem defaultValue={searchValue} placeholder={`Search ${isDesign ? 'patterns' : 'fonts'}`} onChange={debounce(onSearch,150)} themeColor={themeColor}/>
                  </Markup.Global.SelectBox.TitleSearch>

              </Markup.Global.SelectBox.TitleContainer>

              <Markup.Global.SelectBox.FontsContainer>
                {fontlist.map(item => (
                  <Markup.Global.SelectBox.MobileFontItem
                    ref={(ref) => item.val === selected && ref?.scrollIntoView() }
                    key={item.val}
                    selected={item.val === selected}
                    onClick={() => {
                      setSelected(item.val);
                      toggleSelectBox();
                    }}
                    children={item.title}
                  />
                ))}
              </Markup.Global.SelectBox.FontsContainer>
          </>
        </ModalWrapper>
      )}
    </>
  );
}

export default React.memo(SelectBox);

